import { combineReducers } from 'redux';
import usersReducer from './users.reducer';
import alertReducer from './alert.reducer';
import customerReducer from './customer.reducer';
import adminReducer from "./admin.reducer";
import notification from './notification.reducer';

const rootReducer = combineReducers({
  users: usersReducer,
  alert: alertReducer,
  customer: customerReducer,
  admin: adminReducer,
  notification: notification
});

export default rootReducer;
